module.exports = __webpack_public_path__ + "blackoilleaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackoilleaf.png
// module id = 862
// module chunks = 0